import styled from "styled-components";

export const BoardWrapper = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
`;

export const Instructions = styled.div`
  display: flex;
  gap: 18px;

  a {
    flex: 1;
    font-family: var(--font-secondary);
    color: inherit;
    background-color: #f3f0ff;
    font-size: 14px;
    line-height: 1.2;
    border-radius: 10px;
    font-weight: 500;
    display: flex;
    align-items: center;
    padding: 8px;
    gap: 10px;
    cursor: pointer;
  }

  @media (max-width: 575px) {
    flex-direction: column;
  }
`;
